<template>
  <li :class="['list-group-item bs3-padding-right45', {'has-error list-group-item-danger': hasErrors(inputPrefix)}]">
    <input type="hidden" :name="inputPrefix + '.name'" v-model="pRecipient.name" />
    <input type="hidden" :name="inputPrefix + '.email'" v-model="pRecipient.email" />
    <input v-if="hasUser()" type="hidden" :name="inputPrefix + '.userRef.id'" v-model="pRecipient.userRef.id" />
    <input v-if="hasContact()" type="hidden" :name="inputPrefix + '.contactRef.id'" v-model="pRecipient.contactRef.id" />

    <div v-if="hasErrors(inputPrefix)">
      <span v-for="error in getErrors(inputPrefix)" class="help-block text-danger" :key="error">{{ error }}</span>
    </div>

    <address class="bs3-margin-bottom-reset">
      <strong v-if="hasRecipientName()" v-html="getRecipientName()"></strong><br v-if="hasRecipientName()"/>
      <span v-if="hasContactParentName()" v-html="getContactParentName()"></span><br v-if="hasContactParentName()"/>
      <u>{{pRecipient.email}}</u>
    </address>
    <div class="bs3-margin-top10 bs3-margin-right10" style="position: absolute; top: 0; right: 0;">
      <div class="dropdown">
        <button class="btn btn-default btn-xs pull-right remove-recipient" @click.prevent="onRemoveRecipient">
          <i class="fa-light fa-trash-alt"></i>
        </button>
      </div>
    </div>
  </li>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import stringhelpers from "@/helpers/string-helpers";
import refhelpers from "@/helpers/ref-helpers";

export default {
  name: "ShareSaveFormRecipientList",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pIndex: Number,
    pRecipient: Object
  },
  data: function () {
    return {}
  },
  methods: {
    onRemoveRecipient: function() {
      this.$emit('share-recipient-removed', this.pIndex);
    },
    hasUser: function() {
      return refhelpers.isValidRef(this.pRecipient.userRef);
    },
    hasUserName: function() {
      return this.hasUser()
             && 'name' in this.pRecipient.userRef
             && !stringhelpers.isEmptyOrNull(this.pRecipient.userRef.name);
    },
    hasContact: function() {
      return refhelpers.isValidRef(this.pRecipient.contactRef);
    },
    hasContactName: function() {
      return this.hasContact()
             && 'name' in this.pRecipient.contactRef
             && !stringhelpers.isEmptyOrNull(this.pRecipient.contactRef.name);
    },
    hasRecipientName: function() {
      return !stringhelpers.isEmptyOrNull(this.pRecipient.name);
    },
    getRecipientName: function() {
      return this.pRecipient.name
    },
    hasContactParentName: function() {
      return this.hasContact()
             && !$.isEmptyObject(this.pRecipient.contactRef.params)
             && 'parentName' in this.pRecipient.contactRef.params
             && this.pRecipient.contactRef.params.parentName !== undefined;
    },
    getContactParentName: function() {
      return this.hasContactParentName() ? this.pRecipient.contactRef.params.parentName : null;
    }
  },
  computed: {
    inputPrefix: function() {
      return 'dataForm.recipients[' + this.pIndex + ']';
    }
  }
}
</script>

<style scoped>

</style>